<nb-card>
  <div class="title-placeholder"></div>
  <div class="text-placeholder"></div>
  <div class="link-placeholder"></div>
</nb-card>
